export default "__VITE_ASSET__xxSubXpw__"